var App = App || {};

App.ComponentSsBubbles = (function ($) {
    'use strict';

    function Init() {
        $(".component-ssBubbles").each(function () {

            const desktop = $(this).find(".component-ssBubbles-desktop");
            const mobile = $(this).find(".component-ssBubbles-mobile");

            Desktop(desktop);
            Mobile(mobile);
        });
    }

    function Desktop(desktop) {

        const bubbles = desktop.find(".item-ssBubble");
        const open = bubbles.find(".item-ssBubble-intro button");
        const close = bubbles.find(".item-ssBubble-content button");

        open.on("click", function () {
            if ($(this).attr("aria-pressed") == "false") {
                DesktopOpen($(this).parents(".item-ssBubble"));
            }
        });
        close.on("click", function (e) {
            DesktopClose($(this).parents(".item-ssBubble"));
        });

    }

    function DesktopOpen(bubble) {
        var open = bubble.find(".item-ssBubble-intro button");
        var close = bubble.find(".item-ssBubble-content button");

        open.attr("aria-pressed", true);
        close.removeAttr("tabindex");

        bubble.siblings(".item-ssBubble").each(function () {
            DesktopClose($(this));
        });
    }

    function DesktopClose(bubble) {
        var open = bubble.find(".item-ssBubble-intro button");
        var close = bubble.find(".item-ssBubble-content button");
        open.attr("aria-pressed", false);
        close.attr("tabindex", -1);
    }

    function Mobile(mobile) {

        const carousel = mobile.find(".splide");
        const splide = new Splide(carousel[0], {
            type: "loop",
            perPage: 1
        });

        splide.mount({});   
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ComponentSsBubbles.Init();
});